import { graphql } from '@/gql';
import type { SendSmsMessagesMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const sendSMSMessages = async ({ messages, fromNumber, toNumber }: SendSmsMessagesMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      messages,
      fromNumber,
      toNumber,
    },
    mutation: graphql(`
      mutation SendSMSMessages($messages: [String!]!, $fromNumber: String!, $toNumber: String!) {
        sendSMSMessages(messages: $messages, fromNumber: $fromNumber, toNumber: $toNumber)
      }
    `),
  });

  return response.data?.sendSMSMessages ?? false;
};
